<template>
    <d-card id="login-card" class="mx-auto w-65">
        <d-card-img src="./hp-banner.jpg" class="mt-5" fluid />
        <d-card-body title="User Login">
        <d-form @submit="login">
            <d-alert theme="danger" :show="error.length">{{ error }}</d-alert>
            <d-alert theme="success" :show="success.length">{{ success }}</d-alert>
            <div class="form-group">
            <label for="username" class="sr-only">Username</label>
            <d-input
                autofocus
                id="username"
                name="username"
                type="email"
                v-model="username"
                placeholder="Email"
                required
            />
            </div>
            <div class="form-group">
            <label for="password" class="sr-only">Password</label>
            <d-input
                id="password"
                name="password"
                type="password"
                v-model="password"
                placeholder="Password"
                required
            />
            </div>
            <d-button theme="primary">Login</d-button>
            <hr>
            <div>
                <div class="flex-grow-1 text-center">
                    <div id="google-signin" v-if="!signedIn" class="d-inline-block"></div>
                </div>
            </div>
        </d-form>
        </d-card-body>
    </d-card>
</template>

<script>
import AuthService from "@/services/AuthService";
import { mapState } from 'vuex'

export default {
    name: "Login",
    data() {
        return {
        username: "",
        password: "",
        error: "",
        success: "",
        signedIn: false
        };
    },
    computed: {
        ...mapState(['gapiLoaded'])
    },
    mounted() {
        if (this.gapiLoaded) this.renderSignInBtn();
    },
    watch: {
        gapiLoaded: {
            immediate: true,
            handler(loaded) {
                if (loaded) this.renderSignInBtn();
            }
        }
    },
    methods: {
        async login(e) {
            e.preventDefault();
            this.error = "";
            this.success = "";

            try {
                await AuthService.authenticate({
                    username: this.username,
                    password: this.password
                });
                this.success = "Successfully logged in!";
                this.$router.push({ path: 'redirecting' });
            } catch (error) {
                this.error = "Invalid email and/or password entered.";
                this.password = "";
            }
        },
        async onSignIn() {
            const gapi = window.gapi;
            
            let access_token = gapi.auth2.getAuthInstance().currentUser.get().getAuthResponse(true).access_token;

            try {
                await AuthService.loginByGoogle(access_token);
                this.signedIn = true;
                this.success = "Successfully logged in!";
                this.$router.push({ path: 'redirecting' });
            } catch(error) {
                this.error = error;
            }
        },
        renderSignInBtn() {
            const gapi = window.gapi;
            gapi.signin2.render('google-signin', {
                onsuccess: this.onSignIn,
                longtitle: true
            });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    #login-card {
    max-width: 600px;
    }
    hr {
        display: block;
        position: relative;
        &:before {
            content: 'OR';
            color: #777;
            background-color: #fff;
            /* margin-bottom: -33px; */
            display: inline-block;
            position: absolute;
            top: -10px;
            left: 50%;
            width: 50px;
            text-align: center;
            margin-left: -25px;
        }
    }
</style>
